<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/speaker/ysq.jpg" alt="功放系列">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">扬声器系列</div>
                <div class="detail-banner-desc">
                    自主规划设计；<br />
                    先进声学科技打造出色音质；<br />
                    入门-顶级，覆盖多个性能级别，满足各类声学需求；<br />
                    具有：高性能、定制化布置、防水扬声器、种类齐全、绿色环保等特点。
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">AG1 高保真系列</div>
                    <div class="detail-desc">
                        <div>
                            高功率，高可靠性，强耐候性
                        </div>
                        <div>
                            出色的中、高音延展性、低频输出能力
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/speaker/AG1.jpg" alt="AG1 高保真系列">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品优势
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">加大磁路设计 --- 高输出能力<br />低频可下潜至40Hz --- 低频下潜深<br />提供小口径重低音选择 --- 布置灵活</div>
                                    <div class="k">低音&重低音单元</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">加大磁路中音 --- 高工作效率</div>
                                    <div class="k">中音单元</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">丝膜高音  --- 音质细腻柔和</div>
                                    <div class="k">高音单元</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">高功率音圈 --- 高功率<br />铝盆/复合纸盆音盆 --- 瞬态出色，质感清脆</div>
                                    <div class="k">其他特色</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品优势
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">丝膜高音  --- 音质细腻柔和</div>
                                    <div class="k">高音单元</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">高功率音圈 --- 高功率<br />铝盆/复合纸盆音盆 --- 瞬态出色，质感清脆</div>
                                    <div class="k">其他特色</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/speaker/AG1.jpg" alt="AG1 高保真系列">
                    </div>
                </div> -->
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">AG2 豪华系列</div>
                    <div class="detail-desc">
                        <div>
                            更大功率，更高可靠性，更强耐候性
                        </div>
                        <div>
                            优秀的高音延展性 、中音动态表现 、低频输出能力
                        </div>
                    </div>
                </div>

                <!-- <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/speaker/AG2.jpg" alt="AG2 豪华系列">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品优势
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">采用更可靠音圈 --- 更高可靠性<br />低频可下潜至30Hz --- 低频下潜更深</div>
                                    <div class="k">低音&重低音单元</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">双磁钢设计 --- 更高工作效率</div>
                                    <div class="k">中音单元</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品优势
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">采用更可靠音圈 --- 更高可靠性<br />低频可下潜至30Hz --- 低频下潜更深</div>
                                    <div class="k">低音&重低音单元</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">双磁钢设计 --- 更高工作效率</div>
                                    <div class="k">中音单元</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">丝膜高音  --- 音质细腻柔和<br />金属膜高音 --- 音色明亮，具有金属感</div>
                                    <div class="k">高音单元</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">以稀土磁钢为主 --- 更强推力，更轻重量<br />玻纤/Kevlar混编盆音盆 --- 更出色音质</div>
                                    <div class="k">其他特色</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/speaker/AG2.jpg" alt="AG2 豪华系列">
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">AG3 奢华系列</div>
                    <div class="detail-desc">
                        <div>
                            极高功率，极佳可靠性，极强耐候性
                        </div>
                        <div>
                            优异的高音动态表现 、中音音色 、低频输出能力
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/speaker/AG3.jpg" alt="AG3 奢华系列">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品优势
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">低频可下潜至20Hz --- 极致低音下潜震撼<br />提供跑道型产品选择 --- 更适合特殊空间装配</div>
                                    <div class="k">低音&重低音单元</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">全系列Kevlar编织中音 --- 优异的音色</div>
                                    <div class="k">中音单元</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">航空钛膜高音 --- 极佳解析力 & 声音延展性</div>
                                    <div class="k">高音单元</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">全系列稀土磁钢 --- 更好的性能<br />铸铝支架 --- 更强支撑 & 稳定性</div>
                                    <div class="k">其他特色</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品优势
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">航空钛膜高音 --- 极佳解析力 & 声音延展性</div>
                                    <div class="k">高音单元</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">全系列稀土磁钢 --- 更好的性能<br />铸铝支架 --- 更强支撑 & 稳定性</div>
                                    <div class="k">其他特色</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/speaker/AG3.jpg" alt="AG3 奢华系列">
                    </div>
                </div> -->
            </div>
        </div>


    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '扬声器系列 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/speaker.html'
};

import { createApp } from 'vue';
import App from './speaker.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./speaker.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
